var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTransferCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203 0c112 0 203 91 203 203s-91 203-203 203S0 315 0 203 91 0 203 0zM93 152c-4 0-7-3-7-7s3-8 7-8h206l-48-48c-3-3-3-8 0-11 3-2 8-2 11 0l54 55c3 3 5 7 5 12 0 4-2 9-5 12l-54 54c-3 3-8 3-11 0s-3-8 0-11l48-48H93zm62 165c3 3 3 8 0 11s-8 3-11 0l-54-54c-3-4-4-8-4-12 0-5 1-9 5-13l53-53c3-3 8-3 11 0 3 2 3 7 0 10l-48 48h206c4 0 8 4 8 8s-4 7-8 7H107l48 48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTransferCircleFilled);
export default __webpack_public_path__ + "static/media/ArrowTransferCircleFilled.4e16d8444b9e20a3d5998676020658aa.svg";
export { ForwardRef as ReactComponent };